exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".small-wysiwyg .jodit_workplace {\n  height: 360px !important;\n}\n.small-wysiwyg .jodit_container {\n  height: 440px !important;\n}", ""]);

// exports
